// The game's entry point in the browser: real storage, time, sound, motion
// and the solver's worker, handed to the page (src/ui/app.ts).

import ritesFile from "../../static/levels/rites.json" with { type: "json" }
import { parseRites } from "../boundary/rites.ts"
import { browserClock } from "../effects/clock.ts"
import { browserMotion } from "../effects/motion.ts"
import { browserSound } from "../effects/sound.ts"
import { browserStorage } from "../effects/storage.ts"
import { workerThinker } from "../effects/thinker.ts"
import { startApp } from "../ui/app.ts"

const boot = (): void => {
  const raw: unknown = ritesFile
  const rites = parseRites(raw)
  if (rites.tag === "error") throw new Error(`levels/rites.json: ${rites.error.detail}`)
  const handle = startApp({
    doc: document,
    rites: rites.value,
    storage: browserStorage(),
    clock: browserClock(),
    motion: browserMotion(),
    sound: browserSound(false),
    thinker: workerThinker(new URL("./solver-worker.js", import.meta.url)),
    hash: location.hash,
  })
  // for the integration tests and the curious: the state of play
  Object.assign(window, { ternion: handle })
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot)
else boot()
